import DateTimeLabel from '@monorepo/common/component/DateTimeLabel';
import List from '@monorepo/common/component/List';
import MoneyLabel from '@monorepo/common/component/MoneyLabel';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import OrderDetail from '../component/order/OrderDetail';
import { colorForStatus } from '../component/order/OrderDetailView';
import {
  FamilyOrdersDocument,
  FamilyOrdersQuery,
  FamilyOrdersQueryVariables,
  OrderTotalStatusEnum
} from '../graphql-operations';

interface OrderType {
  __typename?: 'OrderTotal';
  id: string;
  orderNumber: string;
  created: string;
  totalPriceDiscounted: number;
  status: OrderTotalStatusEnum;
}

interface OrderRowProps {
  order: OrderType;
}

function OrderRow({ order }: OrderRowProps) {
  return (
    <span>
      {order.orderNumber} | <DateTimeLabel dateTimeString={order.created} /> |{' '}
      <MoneyLabel amount={order.totalPriceDiscounted} />
    </span>
  );
}

export default function OrdersPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:orderNumber?`;
  const match = useRouteMatch<{ orderNumber?: string }>(path);
  const orderNumber = match?.params.orderNumber;

  return (
    <ResponsiveContextProvider single={false} selectedId={orderNumber}>
      <Route path={path}>
        <QueryWithLoader<FamilyOrdersQuery, FamilyOrdersQueryVariables> query={FamilyOrdersDocument}>
          {({ data, loading, error }) => {
            const orders = data.familyOrders;

            return (
              <Container>
                <Row>
                  <ResponsiveListCol>
                    <div className="position-fixed-scrollable">
                      <List
                        items={orders}
                        loading={loading}
                        error={error}
                        selectedId={orderNumber}
                        idExtractor={order => order.orderNumber}
                        urlExtractor={order => `${parentUrl}/${order.orderNumber}`}
                        colorExtractor={order => colorForStatus(order.status)}
                      >
                        {order => <OrderRow order={order} />}
                      </List>
                    </div>
                  </ResponsiveListCol>

                  <ResponsiveDetailCol>
                    <OrderDetail orderNumber={orderNumber} listUrl={parentUrl} />
                  </ResponsiveDetailCol>
                </Row>
              </Container>
            );
          }}
        </QueryWithLoader>
      </Route>
    </ResponsiveContextProvider>
  );
}
